import Styled from 'styled-components'

const Aside = Styled.aside`
  width: 100%;
  height: 100%;
  .background-login{
    position: relative;
    height: 100%;
    background: linear-gradient(180deg, rgba(242, 93, 39, 0) 0%, rgba(242, 93, 39, 0.4) 100%);
  }
  @media only screen and (max-width: 575px){
    .background-login{
      height: auto;
    }
  }

  @media only screen and (max-width: 767px){
    height: 100%;
  }
  img{
    margin-bottom:24px;
  }
  .topShape {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index:-1;
  }
  .bottomShape {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 0px;
    width: 60%;
    z-index:-1;
  }
  @media only screen and (max-width: 767px){
    .bottomShape {
      width: 100%;
    }
  }
  .auth-side-container{
    margin: auto;
  }
  .auth-side-content{
    display: flex;
    justify-content:center;
    @media only screen and (max-width: 991px){
      h1{
        font-size: 20px;
      }
    }
    @media only screen and (max-width: 767px){
      h1{
        font-size: 24px;
        margin-bottom: 28px;
      }
    }
  }
`

const Content = Styled.div`
    /* padding: 100px; */
    display: flex;
    align-items:center;
    flex-direction:column;
    @media only screen and (max-width: 1599px){
      padding: 50px;
    }
    @media only screen and (max-width: 991px){
      padding: 20px;
    }
    @media only screen and (max-width: 575px){
      padding: 20px 0px 0px 0px;
    }
    @media only screen and (max-width: 767px){
      text-align: center;
    }
    .auth-content-figure{
      @media only screen and (max-width: 1199px){
        max-width: 420px;
      }
      @media only screen and (max-width: 991px){
        max-width: 100%;
      }
    }
`

const AuthWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* padding: 40px; */
  @media only screen and (max-width: 1599px){
    padding: 25px 0px;
  }
  
  @media only screen and (max-width: 575px){
    padding: 10px 5px;
  }
  
  @media only screen and (max-width: 767px){
    text-align: center;
  }
  .auth-notice{
    text-align: right;
    font-weight: 500;
    color: ${({ theme }) => theme['gray-color']};
    @media only screen and (max-width: 767px){
      text-align: center;
      margin-bottom: 10px;
    }
  }
  button{
    &.btn-signin{
      min-width: 185px;
    }
    &.btn-create{
      border-radius: 8px;
      min-width: 205px;
    }
    &.btn-reset{
      border-radius: 8px;
      min-width: 260px;
    }
    &.ant-btn-lg{
      font-size: 14px;
      font-weight: 500;
      height: 48px;
    }
  }
  .auth-captha{
    margin-top: 15px;
    margin-bottom: 25px;
  }
  .auth-contents{
    background: #FCF9ED;
    border-radius:24px;
    padding:50px;
    margin:0px 60px;
    width: 100%;
    @media only screen and (max-width: 575px){
      padding:50px 10px;
      margin:0px 60px;
      width: 90%;
    }
    box-shadow: 0px 0px 30px 5px rgba(0,0,0,0.2);
    -webkit-box-shadow: 0px 0px 30px 5px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 30px 5px rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    form{
      width: 100%;
      h1{
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 45px;
        text-align:center;
        @media only screen and (max-width: 767px){
          margin-bottom: 28px;
        }
        input::placeholder{
          color: ${({ theme }) => theme['extra-light-color']};
        }
      }
      .auth-form-action{
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        @media only screen and (max-width: 379px){
          flex-flow: column;
          .forgot-pass-link{
            margin-top: 15px;
          }
        }
      }
      .ant-input:hover, .ant-input-affix-wrapper:hover {
        border-color: var(--antd-wave-shadow-color);
      }

      .ant-input:focus, .ant-input-affix-wrapper-focused, .ant-input-affix-wrapper:focus {
        border-color: var(--antd-wave-shadow-color);
        box-shadow: 0 0 0 2px rgb(242 93 39 / 20%);
      }
    }
    #forgotPass{
      .forgot-text{
        margin-bottom: 25px;
      }
      .return-text{
        margin-top: 35px;
      }
    }
    .form-divider{
      font-size: 13px;
      color: ${({ theme }) => theme['gray-solid']};
      text-align: center;
      position: relative;
      margin-bottom: 25px;
      &:before{
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        height: 1px;
        background: ${({ theme }) => theme['border-color-light']};
      }
      span{
        background: #fff;
        padding: 0 15px;
        display: inline-block;
        position: relative;
        z-index: 2;
      }
    }
    .social-login{
      display: flex;
      align-items: center;
      margin: -6px;
      @media only screen and (max-width: 767px){
        justify-content: center;
      }
      &.signin-social{
        li{
          a{
            box-shadow: 0 5px 15px ${({ theme }) => theme['light-color']}10;
            background-color: #fff;
          }
        }
      }
      li{
        padding:6px;
        a{
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          height: 48px;
          padding: 0 15px;
          border: 1px solid ${({ theme }) => theme['border-color-light']};
          background: ${({ theme }) => theme['bg-color-light']};
          color: ${({ theme }) => theme['text-color']};
          font-weight: 500;
          @media only screen and (max-width: 379px){
            height: 44px;
            padding: 0 12px;
          }
          span:not(.anticon){
            display: inline-block;
            margin-left: 5px;
          }
          svg,
          i{
            width: 20px;
            height: 20px;
          }
          &.google-signup,
          &.google-signin{
            display: flex;
            align-items: center;
            padding: 0 30px;
            @media only screen and (max-width: 379px){
              padding: 0 5px;
            }
            img{
              margin-right: 8px;
              @media only screen and (max-width: 379px){
                margin-right: 4px;
              }
            }
          }
          &.facebook-sign{
            color: #475993;
          }
          &.twitter-sign{
            color: #03A9F4;
          }
        }
      }
    }
  }
`
export { Aside, Content, AuthWrapper }
